export default "__VITE_ASSET__b3d6c50b__"